import { RNPTabs } from '../../../pages/RolesAndPermissions/types';
import { FEATURE_TOGGLE } from '../../../utils/FeatureToggle';

export enum ROUTE_RNP {
  rolesNPermissions = '/roles_and_permissions',
  systemRoles = '/roles_and_permissions/system_roles',
  customRoles = '/roles_and_permissions/custom_roles',
  createNewRole = '/roles_and_permissions/custom_roles/create_role',
  updateCustomRole = `/roles_and_permissions/custom_roles/:roleId/edit`,
}

const getRNPRoutes = () => {
  const routes = [
    {
      path: ROUTE_RNP.rolesNPermissions,
      currentTab: RNPTabs.SYSTEM_ROLES,
    },
    {
      path: ROUTE_RNP.systemRoles,
      currentTab: RNPTabs.SYSTEM_ROLES,
    },
  ];

  if (FEATURE_TOGGLE.RNP_CUSTOM_ROLES) {
    routes.push({
      path: ROUTE_RNP.customRoles,
      currentTab: RNPTabs.CUSTOM_ROLES,
    });
  }

  return routes;
};

export const rolesNPermissionsRoutes = getRNPRoutes();
